export default function validationMessageHandler(formElement) {
    let validationMessage = formElement.validationMessage;
    if (validationMessage === "Please fill out this field." ||  //Chrome / Firefox error message
        validationMessage === "Fill out this field" || //Safari error message
        validationMessage === "Please enter a number." //Firefox error message for number field
    ) {
        const label = document.querySelector("label[for=" + formElement.id + "]");
        if (label.innerText) {
            const questionLabel = label.innerText.includes("?") ? '"' : '';
            const hidesuffix =  formElement.getAttribute('hidesuffix');
            const ariaLabel = formElement.getAttribute('aria-label');
            const newLabel = ariaLabel ? ariaLabel : label.innerText.replace('*','');
            validationMessage = "Please enter the " + questionLabel + newLabel + (formElement.type === 'number' && !hidesuffix?' amount':'') + questionLabel;
        }
    }

    //Chrome error message
    if (validationMessage.includes("Please select ")) {
        const label = document.querySelector("label[for=" + formElement.id + "]");
        if (label.innerText) {
            const questionLabel = label.innerText.includes("?") ? '"' : '';
            const ariaLabel = formElement.getAttribute('aria-label');
            const newLabel = ariaLabel ? ariaLabel : label.innerText.replace('*','');
            validationMessage = "Please select the " + questionLabel + newLabel + questionLabel;
        }
    }

    if (formElement.value !== '' && !formElement.reportValidity()) {
        if (formElement.type === 'checkbox') {
            validationMessage = "Please select at least one."
        } else if (formElement.type === 'tel') {
            validationMessage = "Enter a valid phone number in the following format: (XXX) XXX-XXXX or XXX-XXX-XXXX";
        } else if (formElement.type === 'date' && validationMessage.match('Value')) {
            if (formElement.name) {
                const newName = formElement.name.charAt(0).toUpperCase() + formElement.name.replace( /([a-z])([A-Z])/g, "$1 $2" ).slice(1);
                if (validationMessage.match("later")) {
                    validationMessage = validationMessage.replace("Value must be ", newName + " should be on or after ");
                    validationMessage = validationMessage.replace(" or later.", "");
                } else {
                    validationMessage = validationMessage.replace("Value must be ", newName + " should be on or before ");
                    validationMessage = validationMessage.replace(" or earlier.", "");
                }
            }
        } else if (formElement.type === 'number') {
            const label = document.querySelector("label[for=" + formElement.id + "]");
            if (label.innerText) {
                const questionLabel = label.innerText.includes("?") ? '"' : '';
                const hidesuffix =  formElement.getAttribute('hidesuffix');
                validationMessage = validationMessage.replace("Value",questionLabel + label.innerText.replace('*','') + (!hidesuffix?' amount':'') + questionLabel);
                validationMessage = validationMessage.replace("value",questionLabel + label.innerText.replace('*','') + (!hidesuffix?' amount':'') + questionLabel);
            }
        } else if (formElement.name.endsWith('address')) {
            validationMessage = "Street Address must start with a number";
        } else if (formElement.name.endsWith('zip')) {
            validationMessage = "Enter a zip code in the following format: XXXXX or XXXXX-XXXX";
        } else if (formElement.name.endsWith('city')) {
            validationMessage = "City must have at least 2 characters and cannot include 0-9";
        } else if (formElement.name.endsWith('token-key')) {
            validationMessage = "Token must contains only lowercase characters/hyphen with colon (:) in between";
        } else if (formElement.type == 'textarea') {
            const helperText = document.querySelector("#" + formElement.name + "-helper-text");
            if (helperText && helperText.innerText) {
                validationMessage = helperText.innerText;
            } else {
                validationMessage = 'Please review an error';
            }
        }
    }

    return validationMessage && 'Error: ' + validationMessage;
}